import { render, staticRenderFns } from "./ContaContabilListagemTabela.vue?vue&type=template&id=64f5a70e&"
import script from "./ContaContabilListagemTabela.vue?vue&type=script&lang=js&"
export * from "./ContaContabilListagemTabela.vue?vue&type=script&lang=js&"
import style0 from "./ContaContabilListagemTabela.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VPagination,VSelect,VSpacer})
